<template>
    <div class="nevs-content">
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadRegistrations">
                <tr class="nevs-table-filters">
                    <td>
                        <NevsTextField v-model="tableData.filters.first_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.last_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.card_id"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.member_id"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.email"></NevsTextField>
                    </td>
                    <td></td>
                    <td>
                        <NevsSelect v-model="tableData.filters.offline"
                                    :options="$HELPERS.GetYesNoAllOptions(this)"></NevsSelect>
                    </td>
                </tr>
                <tr v-for="(registration, key) in tableData.records" :key="key">
                    <td>{{ registration.first_name }}</td>
                    <td>{{ registration.last_name }}</td>
                    <td>{{ registration.card_id }}</td>
                    <td>{{ registration.member_id }}</td>
                    <td>{{ registration.email }}</td>
                    <td>{{ registration.time_display }}</td>
                    <td>{{ registration.offline ? $LANG.Get('labels.yes') : $LANG.Get('labels.no') }}</td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";

export default {
    name: "ModuleIntisRegistrations",
    components: {NevsSelect, NevsTextField, NevsTable, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'first_name',
                        label: this.$LANG.Get('fields.firstName')
                    },
                    {
                        name: 'last_name',
                        label: this.$LANG.Get('fields.lastName')
                    },
                    {
                        name: 'card_id',
                        label: this.$LANG.Get('fields.cardId')
                    },
                    {
                        name: 'member_id',
                        label: this.$LANG.Get('fields.memberId')
                    },
                    {
                        // The address lives inside the person's emails JSON, so it can be filtered but not
                        // sorted on.
                        name: 'email',
                        label: this.$LANG.Get('fields.email'),
                        sortable: false
                    },
                    {
                        name: 'time',
                        label: this.$LANG.Get('fields.time')
                    },
                    {
                        name: 'offline',
                        label: this.$LANG.Get('fields.offline')
                    }
                ],
                filters: {
                    first_name: '',
                    last_name: '',
                    card_id: '',
                    member_id: '',
                    email: '',
                    offline: -1
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'time',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            }
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.tableData.filterTimer !== null) {
                    clearTimeout(this.tableData.filterTimer);
                }
                let vm = this;
                this.tableData.filterTimer = setTimeout(function () {
                    vm.reloadRegistrations(vm.tableData.lastRequest);
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        reloadRegistrations(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'intis-registrations', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.tableData.height = window.innerHeight - 205 + 'px';
        }
    },
    mounted() {
        if (!this.$store.state.user.permissions.includes('ADMINISTRATOR') || !this.$store.state.user.client.intis_enabled) {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
            return;
        }
        this.$store.commit('selectMenu', 'settings');
        this.$store.commit('selectSubMenu', 'intisRegistrations');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.settings'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.intisRegistrations'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
    unmounted() {
        window.removeEventListener('resize', this.resolveWindowResize);
    }
}
</script>
